// Maskot "TAKA", burung hantu kecil yang pintar, dengan beberapa ekspresi.
//   happy  : mata tersenyum, sayap kanan melambai setinggi pipi
//   cheer  : bersorak, kedua sayap terangkat, ada kilau
//   think  : melirik ke atas, sayap di dagu
//   wow    : mata bulat besar, paruh terbuka
//   sad    : alis turun, tetap tersenyum kecil (menyemangati)
// Fungsi ini murni (tanpa DOM) supaya bisa dipakai untuk membuat ikon.

const MATA = { kiri: [44, 54], kanan: [76, 54] };

function mata(mood) {
  const [lx, ly] = MATA.kiri, [rx, ry] = MATA.kanan;
  const cincin = `<circle class="m-ring" cx="${lx}" cy="${ly}" r="16"/><circle class="m-ring" cx="${rx}" cy="${ry}" r="16"/>`;
  if (mood === 'happy' || mood === 'cheer') {
    return cincin + `<circle class="m-white" cx="${lx}" cy="${ly}" r="12"/><circle class="m-white" cx="${rx}" cy="${ry}" r="12"/>` +
      `<path class="m-lid" d="M${lx - 8} ${ly + 3} Q${lx} ${ly - 8} ${lx + 8} ${ly + 3}"/><path class="m-lid" d="M${rx - 8} ${ry + 3} Q${rx} ${ry - 8} ${rx + 8} ${ry + 3}"/>`;
  }
  const lihat = { think: [3, -5], sad: [0, 3], wow: [0, 0] }[mood] || [1, 1];
  const r = mood === 'wow' ? 7.5 : 6.5;
  const bola = (x, y) => `<g class="m-eye"><circle class="m-white" cx="${x}" cy="${y}" r="12"/><circle class="m-pupil" cx="${x + lihat[0]}" cy="${y + lihat[1]}" r="${r}"/><circle class="m-shine" cx="${x + lihat[0] + 2.4}" cy="${y + lihat[1] - 2.6}" r="2.4"/><circle class="m-shine" cx="${x + lihat[0] - 2}" cy="${y + lihat[1] + 2.4}" r="1.1"/></g>`;
  return cincin + bola(lx, ly) + bola(rx, ry);
}

function alis(mood) {
  if (mood === 'think') return '<path class="m-brow" d="M32 34 Q42 28 52 34"/><path class="m-brow" d="M68 37 Q78 35 88 38"/>';
  if (mood === 'sad') return '<path class="m-brow" d="M33 38 Q42 33 53 35"/><path class="m-brow" d="M67 35 Q78 33 87 38"/>';
  if (mood === 'wow') return '<path class="m-brow" d="M32 32 Q44 24 54 31"/><path class="m-brow" d="M66 31 Q76 24 88 32"/>';
  return '';
}

function paruh(mood) {
  if (mood === 'wow') return '<path class="m-beak" d="M53 64 L67 64 L60 70Z"/><path class="m-mouth" d="M55 71 Q60 80 65 71Z"/>';
  if (mood === 'happy' || mood === 'cheer') return '<path class="m-beak" d="M53 63 L67 63 L60 70Z"/><path class="m-mouth" d="M55.5 71 Q60 77 64.5 71Z"/>';
  return '<path class="m-beak" d="M53 63 L67 63 L60 73Z"/>';
}

function sayap(mood) {
  const kiri = 'M27 64 C12 70 12 92 26 100 C32 90 33 76 27 64Z';
  const kanan = 'M93 64 C108 70 108 92 94 100 C88 90 87 76 93 64Z';
  const pose = {
    happy: ['', 'm-wave'],
    cheer: ['m-up-l', 'm-up-r'],
    think: ['m-chin', ''],
    wow: ['m-up-l m-small', 'm-up-r m-small'],
    sad: ['', ''],
  }[mood] || ['', ''];
  return `<path class="m-wing m-wl ${pose[0]}" d="${kiri}"/><path class="m-wing m-wr ${pose[1]}" d="${kanan}"/>`;
}

function hiasan(mood) {
  if (mood === 'cheer') return '<path class="m-spark" d="M12 30 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 l7 -3z"/><path class="m-spark s2" d="M106 34 l2.4 5 l5 2.4 l-5 2.4 l-2.4 5 l-2.4 -5 l-5 -2.4 l5 -2.4z"/><circle class="m-spark s3" cx="100" cy="14" r="3"/>';
  if (mood === 'think') return '<circle class="m-bubble" cx="104" cy="26" r="9"/><text class="m-q" x="104" y="31" text-anchor="middle">?</text><circle class="m-bubble" cx="96" cy="40" r="3"/>';
  if (mood === 'wow') return '<path class="m-spark" d="M10 50 l2.4 5 l5 2.4 l-5 2.4 l-2.4 5 l-2.4 -5 l-5 -2.4 l5 -2.4z"/>';
  return '';
}

// Kostum TAKA (dibuka dari level & lencana, lihat src/game/aturan.js). `belakang` digambar di
// belakang badan, `depan` di atas semuanya.
const KAIN = 'stroke="#22244A" stroke-width="2.5" stroke-linejoin="round"';
export const AKSESORI = {
  'topi-pet': { depan: `<path d="M38 27 Q40 6 60 6 Q80 6 82 27Z" fill="#2F9BFF" ${KAIN}/><path d="M74 25 Q92 22 104 30 Q88 33 72 30Z" fill="#1F7AD6" ${KAIN}/><circle cx="60" cy="6" r="3" fill="#FFC531" ${KAIN}/>` },
  syal: { depan: `<path d="M23 74 Q60 90 97 74 L97 83 Q60 99 23 83Z" fill="#FF5C8D" ${KAIN}/><path d="M40 82 l2 9 M52 85 l1 9 M66 85 l-1 9 M78 82 l-2 9" stroke="#FFE14D" stroke-width="3" stroke-linecap="round"/><path d="M78 86 L86 106 L76 106 L71 89Z" fill="#FF5C8D" ${KAIN}/>` },
  'dasi-kupu': { depan: `<path d="M60 79 L46 71 L46 87Z M60 79 L74 71 L74 87Z" fill="#8B5CF6" ${KAIN}/><circle cx="60" cy="79" r="4" fill="#6D3FE0" ${KAIN}/>` },
  'topi-pesta': { depan: `<path d="M47 26 L60 -6 L73 26Z" fill="#1FC08A" ${KAIN}/><path d="M51 17 L69 17 M55 7 L65 7" stroke="#FFE14D" stroke-width="3.5" stroke-linecap="round"/><circle cx="60" cy="-7" r="5" fill="#FF5C8D" ${KAIN}/>` },
  pita: { depan: `<path d="M36 26 L22 16 L24 35Z M36 26 L50 16 L48 35Z" fill="#FF5C8D" ${KAIN}/><circle cx="36" cy="26" r="4.5" fill="#FF8AB0" ${KAIN}/>` },
  headphone: { depan: `<path d="M24 46 Q22 4 60 4 Q98 4 96 46" fill="none" stroke="#22244A" stroke-width="5" stroke-linecap="round"/><path d="M24 46 Q22 4 60 4 Q98 4 96 46" fill="none" stroke="#5A5F86" stroke-width="2"/><rect x="14" y="40" width="13" height="22" rx="6" fill="#FF5C8D" ${KAIN}/><rect x="93" y="40" width="13" height="22" rx="6" fill="#FF5C8D" ${KAIN}/>` },
  'topi-penjelajah': { depan: `<ellipse cx="60" cy="25" rx="34" ry="6" fill="#C98B4B" ${KAIN}/><path d="M42 25 Q43 6 60 6 Q77 6 78 25Z" fill="#E2A65E" ${KAIN}/><path d="M43 20 Q60 23 77 20 L77 24 Q60 27 43 24Z" fill="#6B3E1E"/>` },
  jubah: { belakang: `<path d="M32 40 Q14 76 10 110 Q60 116 110 110 Q106 76 88 40Z" fill="#E8434F" ${KAIN}/><path d="M24 108 Q60 113 96 108" fill="none" stroke="#FFC531" stroke-width="3" stroke-linecap="round"/>` },
  mahkota: { depan: `<path d="M41 27 L42 8 L51 17 L60 3 L69 17 L78 8 L79 27Z" fill="#FFC531" ${KAIN}/><circle cx="60" cy="19" r="3" fill="#FF5C8D"/><circle cx="48" cy="22" r="2.4" fill="#2F9BFF"/><circle cx="72" cy="22" r="2.4" fill="#1FC08A"/>` },
  toga: { depan: `<path d="M44 20 Q60 31 76 20 L76 26 Q60 36 44 26Z" fill="#2B2E5A" ${KAIN}/><path d="M28 15 L60 4 L92 15 L60 26Z" fill="#3A3E73" ${KAIN}/><path d="M60 15 L88 18 L89 32" fill="none" stroke="#FFC531" stroke-width="2.5" stroke-linecap="round"/><circle cx="89" cy="34" r="3.5" fill="#FFC531" ${KAIN}/>` },
  'ikat-kepala': { depan: `<path d="M31 31 Q60 22 89 31 L89 38 Q60 29 31 38Z" fill="#E8434F" ${KAIN}/><path d="M89 33 L106 25 L104 41Z" fill="#E8434F" ${KAIN}/><path d="M57 25 q3 -6 6 0 q-3 4 -6 0Z" fill="#FFE14D" stroke="#22244A" stroke-width="1.5"/>` },
  medali: { depan: `<path d="M50 70 L60 90 L70 70" fill="none" stroke="#2F9BFF" stroke-width="5" stroke-linejoin="round"/><circle cx="60" cy="95" r="9" fill="#FFC531" ${KAIN}/><path d="M60 89.5 l1.6 3.4 3.7.5 -2.7 2.6 .7 3.7 -3.3 -1.8 -3.3 1.8 .7 -3.7 -2.7 -2.6 3.7 -.5z" fill="#FFF4C2"/>` },
};
let KOSTUM_AKTIF = 'polos';
/** Kostum yang dipakai TAKA di semua layar. */
export const setKostum = id => { KOSTUM_AKTIF = AKSESORI[id] ? id : 'polos'; };
export const kostumAktif = () => KOSTUM_AKTIF;

export function mascot(mood = 'happy', size = 84, cls = '', { kostum } = {}) {
  const aks = AKSESORI[kostum ?? KOSTUM_AKTIF] || {};
  return `<svg class="mascot m-${mood} ${cls}" width="${size}" height="${size}" viewBox="0 0 120 120" aria-hidden="true"><g class="m-all">` + (aks.belakang || '') +
    '<ellipse class="m-foot" cx="49" cy="110" rx="8" ry="4.5"/><ellipse class="m-foot" cx="71" cy="110" rx="8" ry="4.5"/>' +
    '<path class="m-body" d="M31 36 L25 12 L46 25 Q60 20 74 25 L95 12 L89 36 Q101 50 100 72 C99 97 82 111 60 111 C38 111 21 97 20 72 Q19 50 31 36Z"/>' +
    '<ellipse class="m-belly" cx="60" cy="86" rx="24" ry="20"/>' +
    '<path class="m-feather" d="M50 82 q4 4 8 0 M62 82 q4 4 8 0 M56 92 q4 4 8 0"/>' +
    sayap(mood) +
    '<path class="m-star" d="M90 9 l2.6 5.4 l5.9 .8 l-4.3 4.1 l1 5.8 l-5.2 -2.8 l-5.2 2.8 l1 -5.8 l-4.3 -4.1 l5.9 -.8z"/>' +
    alis(mood) + mata(mood) +
    '<ellipse class="m-cheek" cx="29" cy="70" rx="6" ry="4"/><ellipse class="m-cheek" cx="91" cy="70" rx="6" ry="4"/>' +
    paruh(mood) + hiasan(mood) + (aks.depan || '') +
    '</g></svg>';
}

// Gaya maskot tanpa variabel CSS, untuk membuat ikon PNG.
export const GAYA_MASKOT = `
.m-body{fill:#FF9A3C;stroke:#22244A;stroke-width:3.5;stroke-linejoin:round}
.m-wing{fill:#F07A1A;stroke:#22244A;stroke-width:3;stroke-linejoin:round}
.m-belly{fill:#FFE8C4}
.m-feather{stroke:#E8A35E;stroke-width:2.5;fill:none;stroke-linecap:round}
.m-ring{fill:#FFC531;stroke:#22244A;stroke-width:2.5}
.m-white{fill:#FFFFFF}
.m-pupil{fill:#22244A}
.m-shine{fill:#FFFFFF}
.m-lid{stroke:#22244A;stroke-width:4;fill:none;stroke-linecap:round}
.m-brow{stroke:#22244A;stroke-width:3.5;fill:none;stroke-linecap:round}
.m-beak{fill:#FFC531;stroke:#22244A;stroke-width:2.5;stroke-linejoin:round}
.m-mouth{fill:#FF5C8D;stroke:#22244A;stroke-width:2;stroke-linejoin:round}
.m-cheek{fill:#FF5C8D;opacity:.5}
.m-foot{fill:#FFC531;stroke:#22244A;stroke-width:2.5}
.m-star{fill:#FFE14D;stroke:#22244A;stroke-width:2;stroke-linejoin:round}
.m-spark{fill:#FFE14D;stroke:#22244A;stroke-width:1.5}
.m-bubble{fill:#FFFFFF;stroke:#22244A;stroke-width:2}
.m-q{font:700 13px sans-serif;fill:#22244A}
`;
